import { Box, Heading, ScrollView } from 'native-base';
import React, { useMemo } from 'react';
import { CareerCenterList } from '../../components/home/CareerCenterList';
import { AdditionalLinksList } from '../../components/resources/AdditionalLinksList';
import { CurriculumLinks } from '../../components/resources/CurriculumLinks';
import { ProfessionalNetworksList } from '../../components/resources/ProfessionalNetworksList';
import { SocialMediaLinks } from '../../components/resources/SocialMediaLinks';
import { PageWrapper, Section } from '../../components/ui';
import { RESOURCE_TYPE_GENERAL, RESOURCE_TYPE_STUDENT, RESOURCE_TYPE_VOLUNTEER, RoleNames } from '../../constants';
import { useCampaign } from '../../hooks';
import { ResourcesStackScreenWithNavProps } from '../../navigation/AppNavigation';
import { useAppSelector } from '../../store';

export const ResourcesScreen: React.FC<ResourcesStackScreenWithNavProps<'Resources'>> = () => {
  const { campaign } = useCampaign();
  const currentUser = useAppSelector((state) => state.auth.currentUser);

  const resourceTypesForUser = useMemo(() => {
    const resourceTypes = [RESOURCE_TYPE_GENERAL];
    if (currentUser && currentUser.role.name === RoleNames.STUDENT) {
      resourceTypes.push(RESOURCE_TYPE_STUDENT);
    }

    if (currentUser && currentUser.role.name === RoleNames.VOLUNTEER) {
      resourceTypes.push(RESOURCE_TYPE_VOLUNTEER);
    }

    return resourceTypes;
  }, [currentUser]);

  return (
    <ScrollView>
      <PageWrapper>
        <Box p={4}>
          <Heading mb={4}>Resources</Heading>
          {campaign && (
            <Section title="Course Curriculum" hideIcon>
              <CurriculumLinks />
            </Section>
          )}
          <Section title="Professional Networks" hideIcon>
            <ProfessionalNetworksList />
          </Section>
          <Section title="Employment" hideIcon>
            <CareerCenterList />
          </Section>
          <AdditionalLinksList types={resourceTypesForUser} />
          <SocialMediaLinks />
        </Box>
      </PageWrapper>
    </ScrollView>
  );
};
